import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getRaceScreenSlice = createSlice({
    name: 'racescreen',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchRaceScreen.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchRaceScreen.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchRaceScreen.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setPedigree, setStatus } = getRaceScreenSlice.actions;
export default getRaceScreenSlice.reducer;

export const fetchRaceScreen = createAsyncThunk('/RaceScreenForSubscriber/fetch', async (Date) => {


    const res = await axios.get(`${getBaseUrl()}RaceScreenForSubscriber?Date=${Date}`);
    const RaceScreen = res.data;
    return RaceScreen.data;
})  